import { TODO } from '@b2b/types/core';
import angular, { IScope, ITimeoutService } from 'angular';

const POS_CREATE_PAGES_FORMS_GIFT_CARDS_STRINGS = {
  LOCALE: {
    TILE_COLOR: 'Tile color',
    PHYSICAL: 'Physical',
    DIGITAL: 'Digital',
  },
  ENUM: {
    PHYSICAL: 'physical',
    DIGITAL: 'digital',
  },
};

PosCreatePagesFormsGiftCardsController.$inject = ['$scope', '$timeout', 'PosConfigService'];

function PosCreatePagesFormsGiftCardsController(
  $scope: IScope & { posCreatePagesFormsGiftCards: TODO },
  $timeout: ITimeoutService,
  PosConfigService: TODO,
) {
  const ctrl = {
    model: {} as TODO,
    list: [
      {
        type: POS_CREATE_PAGES_FORMS_GIFT_CARDS_STRINGS.ENUM.PHYSICAL,
        label: POS_CREATE_PAGES_FORMS_GIFT_CARDS_STRINGS.LOCALE.PHYSICAL,
      },
      {
        type: POS_CREATE_PAGES_FORMS_GIFT_CARDS_STRINGS.ENUM.DIGITAL,
        label: POS_CREATE_PAGES_FORMS_GIFT_CARDS_STRINGS.LOCALE.DIGITAL,
      },
    ],
    selected: '' as TODO,
    reduceList: false,

    title: '',
    subTitle: '',
    color: '',
    showIcon: false,
    isLoaded: false,

    colorCodes: {
      textColor: '',
      backgroundColor: '',
    },

    spectrumConfig: {
      titleText: POS_CREATE_PAGES_FORMS_GIFT_CARDS_STRINGS.LOCALE.TILE_COLOR,
      color: '' as TODO,
    },

    init() {
      $scope.$on('PosCreatePagesFormsController::Update', ctrl.onPosCreatePagesFormsControllerUpdate);
      $scope.$watch('posCreatePagesFormsGiftCards.selected', ctrl.onSelected);
      $scope.$watchCollection('posCreatePagesFormsGiftCards.colorCodes', ctrl.onColorCodesUpdate);
    },

    findCardType(type: string) {
      return ctrl.list.find((cardType) => cardType.type === type) || '';
    },

    hasSelected() {
      return !!(ctrl.selected && typeof ctrl.selected === 'object');
    },

    showAutoComplete(field: string) {
      const input = $('#' + field);

      ctrl.reduceList = false;

      $timeout(() => {
        input.trigger('focus');
      }, 0);
    },

    resetSelected() {
      $timeout(() => {
        if (!ctrl.hasSelected()) {
          ctrl.selected = ctrl.findCardType(ctrl.model.type);
        }
        ctrl.reduceList = false;
      }, 0);
    },

    filterList(viewValue: string) {
      if (viewValue && viewValue.length > 0 && ctrl.reduceList) {
        return ctrl.list.filter((cardType) => cardType.label.toLowerCase().indexOf(viewValue.toLowerCase()) !== -1);
      }

      return ctrl.list;
    },

    getTitle() {
      return 'Enter a title';
    },

    getSubtitle() {
      return ctrl.hasSelected() ? ctrl.selected.label : 'Enter a subtitle';
    },

    remove() {
      $scope.$emit('PosCreatePagesFormsController::RemoveTile', ctrl.model);
    },

    cancel() {
      $scope.$emit('PosCreatePagesFormsController::Cancel', ctrl.model);
    },

    done() {
      ctrl.model.name = ctrl.title || '';
      ctrl.model.subTitle = ctrl.subTitle || (ctrl.hasSelected() ? ctrl.selected.label : '');
      ctrl.model.icon = ctrl.showIcon ? 'giftCard' : 'none';
      ctrl.model.color = PosConfigService.tiles.toColor(ctrl.color);

      if (!ctrl.model.color.a) {
        ctrl.model.color.a = 1;
      }

      ctrl.model.type = ctrl.hasSelected() ? ctrl.selected.type : undefined;

      if (ctrl.model.config.pageId) {
        ctrl.model.config.pageId = null;
        delete ctrl.model.config.pageId;
      }

      PosConfigService.updateTile(PosConfigService.pages.getSelectedPageId(), ctrl.model);
      $scope.$emit('PosCreatePagesFormsController::UpdateTile');
    },

    onSelected(_n: TODO, _o: TODO) {
      if (ctrl.hasSelected() && ctrl.model.type === ctrl.selected.type) {
        ctrl.title = ctrl.model.name || '';
        ctrl.subTitle = ctrl.model.subTitle || '';
      } else {
        ctrl.title = '';
        ctrl.subTitle = '';
      }
    },

    onPosCreatePagesFormsControllerUpdate(_e: TODO, data: TODO) {
      if (data.config.type === 'giftCard') {
        ctrl.model = data;
        ctrl.selected = ctrl.findCardType(ctrl.model.type);

        ctrl.title = ctrl.model.name || '';
        ctrl.subTitle = ctrl.model.subTitle || '';
        ctrl.showIcon = !!(ctrl.model.icon && ctrl.model.icon !== 'none');

        ctrl.spectrumConfig.color = '#000000';
        ctrl.color = PosConfigService.tiles.toHex(PosConfigService.tiles.colorToRgb(ctrl.model));
        $timeout(() => {
          ctrl.spectrumConfig.color = ctrl.color;
        }, 0);

        ctrl.isLoaded = true;
      }
    },

    onColorCodesUpdate(n: TODO, o: TODO) {
      if (n && n !== o) {
        ctrl.color = n.backgroundColor;
      }
    },
  };

  $scope.posCreatePagesFormsGiftCards = ctrl;
  ctrl.init();
}

export const PosCreatePagesFormsGiftCardsControllerModule = angular
  .module('acme.view.application.pos.create.pages.forms.giftcards.controllers', ['acme.common.service.posConfig'])
  .controller('PosCreatePagesFormsGiftCardsController', PosCreatePagesFormsGiftCardsController).name;
